import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { ScanDmcPageInitialData } from "./scanDmcPageInitialData";

export const scanDmcPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.scanDmc(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<ScanDmcPageInitialData>>("/page-data/scandmc"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
